// removed by extract-text-webpack-plugin
module.exports = {"popoverZIndex":"19","popoverOZIndex":"21","divider":"ModificationsTable__divider___2HLSf","gm-style-iw":"ModificationsTable__gm-style-iw___YHvp3","table":"ModificationsTable__table___1cXl5","price":"ModificationsTable__price___2S92z"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Catalog/elements/ModificationsTable.scss
 ** module id = 1351
 ** module chunks = 0
 **/